import { gql } from '@apollo/client';
import { ACTIVITY, USER } from '../../fragments';

export const GET_USER = gql`
  query getUser($id: ID!) {
    user(where: { id: $id }) {
      ...user
      activities {
        ...activity
      }
      organisations {
        id
        createdAt
        updatedAt
        dateArchived
        organisation {
          id
          isFunder
          isInstitution
          isServiceProvider
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
            type {
              id
              name
            }
          }
        }
        status
        role {
          id
          name
        }
        practitionerType
        dataRole
        registrationRole {
          id
          name
        }
        isDefault
      }
    }
  }
  ${ACTIVITY}
  ${USER}
`;
